import React, { forwardRef } from 'react'
import { styled, Tooltip as TooltipBase } from '@mui/material'

export const Root = styled(
  forwardRef(({ className, maxWidth, variant, ...props }, ref) => (
    <TooltipBase {...props} classes={{ ...props.classes, popper: className }} ref={ref} />
  ))
)`
  &.MuiTooltip-popper .MuiTooltip-tooltip {
    background-color: ${props => props.theme.palette.gray[20]};
    border-radius: ${props => (props.variant === 'title' ? '2px' : '3px')};
    box-shadow: none;
    box-sizing: border-box;
    height: auto;
    max-height: ${props => (props.variant === 'title' ? 'initial' : '80px')};
    max-width: ${props => (props.variant === 'title' ? 'initial' : '55ch')};
    padding: ${props => (props.variant === 'title' ? '4px 8px' : '11px 18px')};
  }

  &.MuiTooltip-popper .MuiTooltip-tooltip .MuiTooltip-arrow {
    color: ${props => props.theme.palette.gray[20]};
  }
`

export const Content = styled(({ variant, ...props }) => <div {...props} />)`
  color: ${props => props.theme.palette.brand.white};
  display: flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: ${props => (props.variant === 'title' ? '8px' : '12px')};
  font-weight: 300;
  height: auto;
  hyphens: auto;
  letter-spacing: 0;
  line-height: ${props => (props.variant === 'title' ? '9px' : 'initial')};
  max-height: ${props => (props.variant === 'title' ? 'initial' : '44px')};
  overflow: hidden;

  &:focus,
  &:focus-visible {
    outline: none;
  }
`
